import React from 'react';
import { Heading } from '../../../../../landing.common/heading';
import { Paper } from '../../../../../landing.common';
import styles from './benefits.module.scss';
import classNames from 'classnames';

export const Benefits: React.FC = () => {
    return (
        <div className={styles.root}>
            <div className={styles.grid_1}>
                <Paper className={styles.guardPart}>
                    <Heading level={3} className={styles.benefitHeader}>
                        Личные данные
                        <br /> надёжно защищены
                    </Heading>
                    <p className={styles.benefitDescription}>
                        Мы храним их в зашифрованном виде <br /> и используем только для расчёта условий <br /> по
                        кредитным картам
                    </p>
                    <div className={styles.img} />
                </Paper>
                <div className={styles.grid_2}>
                    <Paper>
                        <Heading level={4} className={styles.benefitHeader}>
                            Решение онлайн
                        </Heading>
                        <p className={styles.benefitDescription}>
                            Банки вернутся с решением по&nbsp;кредитным&nbsp;картам после&nbsp;отправки&nbsp;заявки
                        </p>
                    </Paper>
                    <Paper>
                        <Heading level={4} className={styles.benefitHeader}>
                            Никакой комиссии
                        </Heading>
                        <p className={classNames(styles.benefitDescription, styles.commissionDescription)}>
                            Сервис подбора — абсолютно бесплатный, а условия кредитных карт&nbsp;— такие же, как на
                            сайтах банков
                        </p>
                    </Paper>
                </div>
            </div>
            <Paper className={styles.banksPart}>
                <div>
                    <Heading level={3} className={styles.benefitHeader}>
                        Высокая вероятность одобрения
                    </Heading>
                    <p className={styles.benefitDescription}>
                        Покажем только те банки, которые вероятнее всего одобрят вам кредитную карту
                    </p>
                </div>
                <div className={styles.img} />
            </Paper>
        </div>
    );
};
